import React from "react";
import GameContainer from "../../../../../edu_lms/components/Game";
import SenFindingContainer from "../../../../../edu_lms/components/Game/SenFinding";

const SentenceFinding = ({ activity, bookId, showResult }) => {
	
	return (
		<GameContainer data={activity}>
			<SenFindingContainer data={activity} objectId={bookId} showResult={showResult} />
		</GameContainer>
	);
};

export default SentenceFinding;
